import { useSessionContext } from './SessionContext.ts';
import { Link } from '../shell/router.tsx';
import { downloadHostLauncher } from './hostLauncher.ts';
import { ResetForNewGroup } from './ResetForNewGroup.tsx';

/** Private preparation view, available only after the server authenticates the host. */
export function HostPreparation() {
  const { view, self, sessionId, credentials } = useSessionContext();
  if (!self?.isHost) return <p>Host access is required. <Link to="/host">Open host access</Link></p>;
  const host = view.session.participants.find(p => p.id === self.participantId);
  const running = view.session.status === 'running';
  return <section className="stack" style={{maxWidth: 680, margin: '32px auto', width: '100%'}}>
    <span className="momentum-entry-kicker">Momentum · Host preparation</span>
    <h1>You’re the host, {host?.displayName}.</h1>
    <p role="status">{running ? 'Your previous game is still in progress.' : view.session.status === 'lobby' ? 'Your room is in the lobby. You control when play starts.' : 'This game has finished.'}</p>
    <div className="card stack">
      <h2>Prepare for your presentation</h2>
      <p>For a clean rehearsal or a new audience, reset the room below. You stay as host; the old guest link is replaced with a fresh invitation.</p>
      <ResetForNewGroup />
    </div>
    <div className="row">
      <Link className="button button-primary" to="/">Open prototype from the start</Link>
      <Link className="button" to={`/s/${sessionId}`}>{running ? 'Resume current game' : 'Open lobby'}</Link>
    </div>
    <button className="button" onClick={() => downloadHostLauncher(window.location.origin, sessionId, credentials)}>Save private host launcher</button>
    <Link to="/presentation/#1">Open presentation from slide one</Link>
    <p className="text-muted">Invite people from the lobby before you press Start game. Use your private launcher for yourself; share only the guest invitation with your team.</p>
  </section>;
}
